import { skipToken, useQuery } from "@tanstack/react-query";
import { getClaims } from "../api/utils.js";
import { IncorrectPermissionsError, NoAuthTokenError } from "./errors.js";
import { useApi } from "../api/api-provider.js";

// TODO find a way to reuse the same type in the @workos-inc/node package
type WidgetScope =
  | "widgets:users-table:manage"
  | "widgets:sso:manage"
  | "widgets:domain-verification:manage"
  | "widgets:dsync:manage"
  | "widgets:api-keys:manage"
  | "widgets:audit-log-streaming:manage";

export function usePermissions(scope: WidgetScope) {
  const { authToken } = useApi();

  return useQuery({
    queryKey: ["permission", scope, authToken],
    queryFn: authToken
      ? async () => {
          const { permissions } = getClaims(authToken);

          // When the permissions is not present in the token
          if (!permissions || !Array.isArray(permissions)) {
            throw new NoAuthTokenError();
          }

          // When the scope is not present in the permissions
          if (!permissions.includes(scope)) {
            throw new IncorrectPermissionsError();
          }

          return true;
        }
      : skipToken,
  });
}
